import React from 'react';
import SEOAnalyzer from '../components/SEOAnalyzer';
import './SiteAudit.css';

const SiteAudit = ({ user, onLogout, currentProject }) => {
  return (
    <div className="site-audit-page">
      <SEOAnalyzer user={user} onLogout={onLogout} currentProject={currentProject} />
    </div>
  );
};

export default SiteAudit;
